module.exports = __webpack_public_path__ + "static/media/TajMahal.50c4e7e7.png";